export const API_URL = process.env.REACT_APP_API_URL;
export const API_FILE_URL = process.env.REACT_APP_API_FILE_URL;